<template>
  <div class="locale-changer">
    <v-menu>
      <template v-slot:activator="{ on }">
        <button class="button" v-on="on">
          <img v-if="$i18n.locale == 'nl'"
            :aspect-ratio="16/9"
            class="flag_icon"
            :src="require(`../assets/flag_${$i18n.locale}.png`)"
          />
          <img v-if="$i18n.locale == 'en'"
            :aspect-ratio="16/9"
            class="flag_icon mb-1"
            :src="require(`../assets/flag_${$i18n.locale}.png`)"
          />
        </button>
      </template>
      <v-list>
        <v-list-item @click="setLocale('nl')">
          <img :aspect-ratio="16/9" class="flag_icon" src="../assets/flag_nl.png" />
        </v-list-item>
        <v-list-item @click="setLocale('en')">
          <img :aspect-ratio="16/9" class="flag_icon" src="../assets/flag_en.png" />
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  data() {
    return { langs: ["en", "nl"], lang: this.$route.params.lang };
  },
  methods: {
    setLocale(locale) {
      if (locale != this.$i18n.locale) {
        this.$i18n.locale = locale;
        this.$router.push({
          params: { lang: locale }
        });
      }
    }
  }
};
</script>

<style scoped>
.flag_icon {
  width: 20px;
  background-color: white;
}
.test {
  display: inline-block;
}
.button {
  width: 25px;
  text-decoration: none;
}
</style>